export default __webpack_public_path__ + "static/media/logo2.3815d0e8.svg";